import React from "react";
import {
  Briefcase,
  Home,
  Coffee,
  Trophy,
  Flag,
  PartyPopper,
  ArrowRight,
  CheckCircle2,
  Gift,
  Moon,
  Phone, // Added for the Nana Call
} from "lucide-react";

const DayColumn = ({ date, label, theme, blocks }) => (
  <div className="flex-1 min-w-[250px] bg-white rounded-xl border border-stone-200 overflow-hidden flex flex-col">
    {/* Header */}
    <div className={`p-4 border-b border-stone-100 ${theme}`}>
      <div className="text-xs font-bold uppercase tracking-widest opacity-70 mb-1">
        {date}
      </div>
      <h3 className="text-lg font-bold text-stone-800">{label}</h3>
    </div>

    {/* Blocks */}
    <div className="p-4 space-y-3 flex-1 bg-stone-50/50">
      {blocks.map((block, i) => (
        <div
          key={i}
          className={`p-3 rounded-lg border ${block.style} flex items-start gap-3 shadow-sm`}
        >
          <div className={`mt-1 ${block.iconColor}`}>
            <block.icon className="w-4 h-4" />
          </div>
          <div>
            <div className="text-sm font-bold text-stone-700">
              {block.title}
            </div>
            <div className="text-xs text-stone-500 mt-0.5 leading-relaxed">
              {block.sub}
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
);

const WeekSummary = ({ onNavigate }) => {
  return (
    <div className="space-y-6">
      {/* Header: Our Holiday Rhythm */}
      <div className="bg-[#1F6F54] rounded-xl p-6 text-white shadow-lg flex justify-between items-center relative overflow-hidden">
        <div className="relative z-10">
          <h2 className="text-2xl font-bold mb-2">Our Holiday Rhythm</h2>
          <p className="text-emerald-100 text-sm max-w-2xl leading-relaxed opacity-90">
            <strong>Monday:</strong> Clearing space.
            <strong> Tuesday:</strong> Showing up.
            <strong> Wednesday:</strong> Being together.
            <strong> Thursday:</strong> Celebrating & Resting.
          </p>
        </div>
        <div className="bg-white/10 p-3 rounded-full">
          <Flag className="w-8 h-8 text-emerald-200" />
        </div>
      </div>

      {/* The Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {/* MONDAY: Creating Space */}
        <DayColumn
          date="Mon 22"
          label="Creating Space"
          theme="bg-amber-50"
          blocks={[
            {
              title: "Strategy: The Protocol",
              sub: "Eric Update & Matt's Email. Assess Role.",
              icon: Flag,
              style: "bg-white border-indigo-200",
              iconColor: "text-indigo-600",
            },
            {
              title: "Clear The Air",
              sub: "Mom Food Plan (Done). Cleaners (10a).",
              icon: Home,
              style: "bg-white border-amber-200",
              iconColor: "text-amber-600",
            },
            {
              title: "Reward: Golf Sim",
              sub: "7pm Boys Night @ GolfX.",
              icon: Flag,
              style: "bg-stone-800 border-stone-700 text-stone-300",
              iconColor: "text-emerald-400",
            },
          ]}
        />

        {/* TUESDAY: Showing Up */}
        <DayColumn
          date="Tue 23"
          label="Showing Up"
          theme="bg-rose-50"
          blocks={[
            {
              title: "High-Leverage AM",
              sub: "Life Coach (10a) + Coffee Mtg (11a).",
              icon: Coffee,
              style: "bg-white border-emerald-200",
              iconColor: "text-emerald-700",
            },
            {
              title: "Melyssa Support",
              sub: "Cheer Taxi + Party Host Logic.",
              icon: Home,
              style: "bg-white border-rose-200",
              iconColor: "text-rose-600",
            },
            {
              title: "Eve Eve Party",
              sub: "Matt Blue's -> Arigna Pub.",
              icon: PartyPopper,
              style: "bg-indigo-50 border-indigo-200",
              iconColor: "text-indigo-600",
            },
          ]}
        />

        {/* WEDNESDAY: Being Together */}
        <DayColumn
          date="Wed 24"
          label="Being Together"
          theme="bg-emerald-50"
          blocks={[
            {
              title: "No Work",
              sub: "Laptop closed. Notifications off.",
              icon: CheckCircle2,
              style: "bg-white border-stone-200 opacity-50",
              iconColor: "text-stone-400",
            },
            {
              title: "Food Prep",
              sub: "Final cooking for the 25th.",
              icon: Home,
              style: "bg-white border-emerald-200",
              iconColor: "text-emerald-600",
            },
            {
              title: "Christmas Eve",
              sub: "Traditions & Family Time.",
              icon: PartyPopper,
              style: "bg-emerald-100 border-emerald-300",
              iconColor: "text-emerald-700",
            },
          ]}
        />

        {/* THURSDAY: The Celebration */}
        <DayColumn
          date="Thu 25"
          label="The Celebration"
          theme="bg-rose-100"
          blocks={[
            {
              title: "6:00 AM: The Magic", // New Block
              sub: "Wake Up -> 6:02 AM Video Call Nana (Canada) for surprises.",
              icon: Phone,
              style: "bg-white border-indigo-200",
              iconColor: "text-indigo-600",
            },
            {
              title: "Morning Home",
              sub: "Presents & Breakfast at our house until 2pm.",
              icon: Home,
              style: "bg-white border-emerald-200",
              iconColor: "text-emerald-600",
            },
            {
              title: "Nana & Papa's",
              sub: "Depart at 2:00 PM EST.",
              icon: Gift,
              style: "bg-white border-rose-300",
              iconColor: "text-rose-600",
            },
            {
              title: "Sleepover",
              sub: "Staying the night. Return Dec 26 @ 10am.",
              icon: Moon,
              style: "bg-indigo-50 border-indigo-200",
              iconColor: "text-indigo-600",
            },
          ]}
        />
      </div>

      <div className="flex justify-center pt-4">
        <button
          onClick={() => onNavigate("2025-12-22")}
          className="flex items-center gap-2 text-stone-400 hover:text-[#1F6F54] transition-colors font-medium text-sm"
        >
          Dive into Today <ArrowRight className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default WeekSummary;
